/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UpdateOrganizationPaymentCancelResponseDataFromJSON, UpdateOrganizationPaymentCancelResponseDataToJSON } from './UpdateOrganizationPaymentCancelResponseData';
export function UpdateOrganizationPaymentCancelResponseFromJSON(json) {
    return UpdateOrganizationPaymentCancelResponseFromJSONTyped(json, false);
}
export function UpdateOrganizationPaymentCancelResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: json['status'],
        data: UpdateOrganizationPaymentCancelResponseDataFromJSON(json['data'])
    };
}
export function UpdateOrganizationPaymentCancelResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: UpdateOrganizationPaymentCancelResponseDataToJSON(value.data)
    };
}
